module.exports = __webpack_public_path__ + "img/dataservice_lssws.e9ae2e31.png";